"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallTools = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../../context/room_session");
const rxjs_1 = require("../../../../hooks/rxjs");
const streemshot_button_1 = require("./streemshot_button");
const toolbar_button_1 = require("./toolbar_button");
// Sequence in which ToolTypes appear in the UI
const AR_TOOLS_ORDER = ['LASER', 'MARKER'];
const CallTools = ({ disabled, isTrayOpen }) => {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [chosenTool] = (0, rxjs_1.useObservable)(roomSession.tools.activeTool);
    const chosenToolIndex = AR_TOOLS_ORDER.indexOf(chosenTool);
    const [snackbarNotifications, setSnackbarNotifications] = (0, react_1.useState)([]);
    const [toastTimeout, setToastTimeout] = (0, react_1.useState)({});
    const theme = (0, ui_react_1.useTheme)();
    const addNotification = (id) => {
        const TIMEOUT = 2000;
        setSnackbarNotifications([
            {
                id,
                message: 'Streemshot captured!',
                timeout: TIMEOUT,
                icon: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { color: theme.colors.green50, name: "DoneIcon" }),
            },
        ]);
        removeNotificationViaTimeout(id, TIMEOUT);
    };
    const removeNotificationViaTimeout = (id, timeout) => {
        if (toastTimeout && toastTimeout[id]) {
            window.clearTimeout(toastTimeout[id]);
        }
        const remove = window.setTimeout(() => removeNotification(id), timeout);
        setToastTimeout(prevToastTimeout => (Object.assign(Object.assign({}, prevToastTimeout), { [id]: remove })));
    };
    const removeNotification = (id) => {
        setSnackbarNotifications(prevSnackbarNotifications => {
            return prevSnackbarNotifications.filter(notification => notification.id !== id);
        });
    };
    (0, react_1.useEffect)(() => {
        if (disabled) {
            roomSession.tools.setActiveTool('LASER');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StreemshotButtonWrapper, Object.assign({ buttonDisabled: disabled, isTrayOpen: isTrayOpen }, { children: (0, jsx_runtime_1.jsx)(streemshot_button_1.StreemshotButton, { disabled: disabled, addNotification: addNotification }) })), (0, jsx_runtime_1.jsxs)(ui_react_1.IconButtonRow, Object.assign({ activeItemIndex: disabled ? undefined : chosenToolIndex }, { children: [(0, jsx_runtime_1.jsx)(toolbar_button_1.ToolbarButton, { activeTool: chosenTool, label: "Laser Pointer", iconName: "LaserPointerIcon", toolName: "LASER", disableButton: disabled, disableTooltip: disabled, "data-testid": "laser-pointer-button" }), (0, jsx_runtime_1.jsx)(toolbar_button_1.ToolbarButton, { activeTool: chosenTool, label: "Marker", iconName: "MarkerIcon", toolName: "MARKER", disableButton: disabled, disableTooltip: disabled, "data-testid": "marker-button" })] })), (0, jsx_runtime_1.jsx)(ui_react_1.Snackbar, { "data-testid": "streemshot-snackbar-message", content: snackbarNotifications, isTrayOpen: isTrayOpen, position: { vertical: 'top', horizontal: 'center' } })] }));
};
exports.CallTools = CallTools;
const StreemshotButtonWrapper = ui_react_1.styled.div(({ buttonDisabled, isTrayOpen, theme }) => ({
    padding: '4px',
    marginRight: '16px',
    backgroundColor: buttonDisabled ? 'rgba(255, 255, 255, 0.5)' : theme.colors.white,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [`@media ${theme.mediaBreakpoints.small}`]: {
        marginLeft: isTrayOpen ? '24px' : '0px',
    },
}));
//# sourceMappingURL=call_tools.js.map